import { jsxs as f, jsx as e } from "react/jsx-runtime";
import { Stack as u, Paper as k, Typography as h, Box as x, useTheme as v } from "@mui/material";
import "../../queries/message/index.js";
import "../../queries/contact/index.js";
import "../../queries/calendars/index.js";
import { D as E } from "../../index-DVHhaa_b.js";
import "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import "../../queries/files/index.js";
import { attendance as n } from "../../queries/attendance/index.js";
import "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
import { Legend as B, LegendItem as M } from "../legend/index.js";
import { useState as R } from "react";
import S from "dayjs";
const F = [
  { label: "January", i: 0 },
  { label: "February", i: 1 },
  { label: "March", i: 2 },
  { label: "April", i: 3 },
  { label: "May", i: 4 },
  { label: "June", i: 5 },
  { label: "July", i: 6 },
  { label: "August", i: 7 },
  { label: "September", i: 8 },
  { label: "October", i: 9 },
  { label: "November", i: 10 },
  { label: "December", i: 11 }
];
function ce({ studentId: p, classId: r, reportYear: g, current: c }) {
  const s = /* @__PURE__ */ new Date(), l = s.getFullYear();
  s.setFullYear(g ?? l);
  const d = s.getFullYear(), i = d < l ? 11 : s.getMonth(), { data: y, isPending: t } = new n.AttendanceMap({ studentId: p, classId: r, year: c ? 0 : d }).ToQuery();
  if (t)
    return null;
  let o = Object.keys(y).map((a) => y[a]);
  return /* @__PURE__ */ f(u, { spacing: 2, children: [
    /* @__PURE__ */ f(B, { title: `Tap a date to view period level attendance${r ? " for this class" : ""}`, children: [
      /* @__PURE__ */ e(b, { type: n.AbsenceTypeEnum.Present }),
      /* @__PURE__ */ e(b, { type: n.AbsenceTypeEnum.Unapproved }),
      /* @__PURE__ */ e(b, { type: n.AbsenceTypeEnum.NoRollMarking }),
      /* @__PURE__ */ e(b, { type: n.AbsenceTypeEnum.Approved }),
      /* @__PURE__ */ e(b, { type: n.AbsenceTypeEnum.Late }),
      /* @__PURE__ */ e(b, { type: n.AbsenceTypeEnum.UnmarkedRoll })
    ] }),
    /* @__PURE__ */ e(u, { direction: "row", flexWrap: "wrap", gap: 2, rowGap: 2, justifyContent: "center", children: F.map((a) => a.i > i ? null : /* @__PURE__ */ e(j, { year: d, monthIndex: a.i, attendance: o }, a.i)) })
  ] });
}
function b({ type: p }) {
  const { bgColor: r, label: g } = w(p);
  return /* @__PURE__ */ e(M, { label: g, color: r });
}
const D = [
  { label: "Mo", i: 1 },
  { label: "Tu", i: 2 },
  { label: "We", i: 3 },
  { label: "Th", i: 4 },
  { label: "Fr", i: 5 },
  { label: "Sa", i: 6 },
  { label: "Su", i: 0 }
];
function j({ year: p, monthIndex: r, attendance: g }) {
  var y;
  const [c, s] = R();
  let l = new Date(p, r, 1), d = r, i = [];
  for (; d === r; ) {
    let t, o = new Date(l);
    i.length === 0 ? (t = { weekIndex: 0, days: [{ dayOfWeekIndex: l.getDay(), date: o }] }, i.push(t)) : o.getDay() === 1 ? (t = { weekIndex: i.length, days: [{ dayOfWeekIndex: l.getDay(), date: o }] }, i.push(t)) : i[i.length - 1].days.push({ dayOfWeekIndex: l.getDay(), date: o }), l.setDate(l.getDate() + 1), d = l.getMonth();
  }
  return /* @__PURE__ */ f(k, { sx: {
    p: 1,
    border: "1px solid rgba(var(--mui-palette-common-onBackgroundChannel) / .3)",
    borderRadius: 1,
    boxShadow: "var(--mui-shadows-3)"
  }, children: [
    /* @__PURE__ */ e(E, { open: !!c, onClose: () => s(void 0), children: /* @__PURE__ */ e(u, { spacing: 1, p: 2, children: c == null ? void 0 : c.split(/\r\n|\s\*\s/).map((t, o) => t && /* @__PURE__ */ e(h, { variant: o === 0 ? "h6" : "body2", children: t }, o)) }) }),
    /* @__PURE__ */ f(u, { spacing: 1, children: [
      /* @__PURE__ */ e(h, { children: (y = F.find((t) => t.i === r)) == null ? void 0 : y.label }),
      /* @__PURE__ */ e(u, { direction: "row", spacing: 1, children: D.map((t) => /* @__PURE__ */ e(x, { width: 30, children: /* @__PURE__ */ e(h, { variant: "body2", children: t.label }) }, t.i)) }),
      i.map((t) => /* @__PURE__ */ e(u, { direction: "row", spacing: 1, children: D.map((o) => {
        const a = t.days.find((A) => A.dayOfWeekIndex === o.i), m = g.find((A) => S(A.AbsenceDate).isSame(a == null ? void 0 : a.date));
        let T, C;
        return m && ({ color: T, bgColor: C } = w(m.AbsenceType)), /* @__PURE__ */ e(
          x,
          {
            width: 30,
            height: 30,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: C,
            borderRadius: "50%",
            onClick: () => s(m == null ? void 0 : m.AbsenceDescription),
            sx: { cursor: m ? "pointer" : void 0 },
            children: /* @__PURE__ */ e(h, { variant: "caption", color: T, children: a == null ? void 0 : a.date.getDate() })
          },
          o.i
        );
      }) }, t.weekIndex))
    ] })
  ] });
}
const w = (p) => {
  const r = v();
  switch (p) {
    case n.AbsenceTypeEnum.Present:
      return { bgColor: "#B4F885", color: r.palette.getContrastText("#B4F885"), label: "Present" };
    case n.AbsenceTypeEnum.NoRollMarking:
      return { bgColor: "#F6F2BA", color: r.palette.getContrastText("#F6F2BA"), label: "No Classes" };
    case n.AbsenceTypeEnum.UnmarkedRoll:
      return { bgColor: "#9BDBF8", color: r.palette.getContrastText("#9BDBF8"), label: "Roll not marked" };
    case n.AbsenceTypeEnum.Late:
      return { bgColor: "#FF9400", color: r.palette.getContrastText("#FF9400"), label: "Late" };
    case n.AbsenceTypeEnum.Unapproved:
      return { bgColor: "#FF0000", color: r.palette.getContrastText("#FF0000"), label: "Unapproved Absence" };
    case n.AbsenceTypeEnum.Approved:
    default:
      return { bgColor: "#D9C681", color: r.palette.getContrastText("#D9C681"), label: "Approved Absence" };
  }
};
export {
  ce as AttendanceMap
};
//# sourceMappingURL=AttendanceMap.js.map
